module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container modal-container-80",
    staticStyle: {
      "width": "300px"
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-body m-0",
    staticStyle: {
      "margin": "auto"
    }
  }, [(_vm.qrCodeIsGenerating) ? _c('div', {
    staticClass: "center text-center scan-pending"
  }, [_c('b-spinner')], 1) : (_vm.showQRCode) ? _c('qr-code-vue', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "value": _vm.accountData.token,
      "size": "260",
      "level": "M"
    }
  }) : (!_vm.demoMode) ? _c('div', {
    staticClass: "form"
  }, [_c('b-row', [_vm._v("\n            " + _vm._s(_vm.$t("bank_accounts.slct_qr_code_content")) + "\n            ")]), _vm._v(" "), _c('b-row', [_c('b-form-group', [_c('b-form-radio', {
    attrs: {
      "name": "type-radio",
      "value": "1"
    },
    model: {
      value: (_vm.qrCodeType),
      callback: function($$v) {
        _vm.qrCodeType = $$v
      },
      expression: "qrCodeType"
    }
  }, [_vm._v("\n                  IBAN\n                ")]), _vm._v(" "), _c('b-form-radio', {
    attrs: {
      "name": "type-radio",
      "value": "2"
    },
    model: {
      value: (_vm.qrCodeType),
      callback: function($$v) {
        _vm.qrCodeType = $$v
      },
      expression: "qrCodeType"
    }
  }, [_vm._v("\n                  QXBAN\n                ")]), _vm._v(" "), _c('b-form-radio', {
    attrs: {
      "name": "type-radio",
      "value": "3"
    },
    model: {
      value: (_vm.qrCodeType),
      callback: function($$v) {
        _vm.qrCodeType = $$v
      },
      expression: "qrCodeType"
    }
  }, [_vm._v("\n                  QXBAN Temporaire / One time use\n                ")])], 1)], 1), _vm._v(" "), (_vm.qrCodeType === '3') ? _c('b-row', [_c('label', [_vm._v("Durée de validité du QRCode")]), _vm._v(" "), _c('b-input-group', {
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('b-form-select', {
          staticStyle: {
            "font-size": "small"
          },
          attrs: {
            "options": _vm.listDuration
          },
          model: {
            value: (_vm.durationUnit),
            callback: function($$v) {
              _vm.durationUnit = $$v
            },
            expression: "durationUnit"
          }
        })]
      },
      proxy: true
    }], null, false, 1219814511)
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Enter a duration"
    },
    model: {
      value: (_vm.validityDuration),
      callback: function($$v) {
        _vm.validityDuration = $$v
      },
      expression: "validityDuration"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-row', [(!_vm.demoMode) ? _c('b-col', [(_vm.showQRCode) ? _c('button', {
    staticClass: "button-action firstButtonMarginTop",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.newQRCode()
      }
    }
  }, [_vm._v("Nouveau QRCode")]) : _c('button', {
    staticClass: "button-action firstButtonMarginTop",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.generateQRCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.generate')))])]) : _vm._e(), _vm._v(" "), _c('b-col', [_c('button', {
    staticClass: "button-action",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.bck')))])])], 1)], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0e2f5c38", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e2f5c38","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/popups/bankAccounts/BankAccountQRCode.vue
// module id = 2331
// module chunks = 2